const Breadcrumb = {
    state: {
        paths: sessionStorage.getItem('App.Breadcrumb') || '[]'
    },
    mutations: {
        setBreadcrumb(state, payload) {
            state.paths = JSON.stringify(payload)
            sessionStorage.setItem('App.Breadcrumb', JSON.stringify(payload))
        }
    }
}

export default Breadcrumb
